import { StringDecoder } from "string_decoder";
import { TranRecordModel } from "./tran-record.model";

export class UpdateTranInfoModel {
    tmpTran: TranRecordModel
    sglLinkCost: number
    strLinkFix: string
    sglLinkUnit: number
    strChkCost: string
    sglProcPrice: number
    intIndicationID: number = 0
    strRoute:string = ''
    strLocation: string = ''
    strFrequency: string = ''  
    strDuration: number = 0
    strUnitDosage: string = ''
    dblQty: number = 0
    constructor(
        tmpTran: TranRecordModel,
        sglLinkCost: number,
        strLinkFix: string,
        sglLinkUnit: number,
        strChkCost: string,
        sglProcPrice: number,
        intIndicationID: number,
        strRoute:string, 
        strLocation: string ,
        strFrequency: string ,  
        strDuration: number, 
        strUnitDosage:string,
        dblQty: number 
    ) {
        this.tmpTran = tmpTran
        this.sglLinkCost = sglLinkCost
        this.strLinkFix = strLinkFix
        this.sglLinkUnit = sglLinkUnit
        this.strChkCost = strChkCost
        this.sglProcPrice = sglProcPrice
        this.intIndicationID = intIndicationID
        this.strRoute = strRoute
        this.strLocation = strLocation
        this.strFrequency = strFrequency 
        this.strDuration =  strDuration
        this.strUnitDosage = strUnitDosage
        this.dblQty = dblQty
    }
}